import { abbrNumberFilter, numberFilter, percentageFilterWithoutNA, percentageSignFilter } from "app/filters/ngFilters";

import { ERankTrackerPerformanceOvertimeTabs } from "../types";

export const getOverviewGraphYAxisFilter = (tab: ERankTrackerPerformanceOvertimeTabs): ((val: number) => string) => {
    switch (tab) {
        case ERankTrackerPerformanceOvertimeTabs.CLICKS:
            return abbrNumberFilter();
        case ERankTrackerPerformanceOvertimeTabs.SHARE_OF_VOICE:
            return (val) => percentageFilterWithoutNA()(val, 1);
        case ERankTrackerPerformanceOvertimeTabs.VISIBILITY:
            return (val) => percentageSignFilter()(val, 1);
        case ERankTrackerPerformanceOvertimeTabs.AVG_WEIGHTED_POSITION:
            return numberFilter();
    }
};
